var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup__forgot-password signup__forgot-password--ledian pb-4"},[_c('router-link',{staticClass:"forgot-password-link--ledian",attrs:{"to":"/forgot-password"}},[_vm._v("\n    パスワードをお忘れの方はこちら\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }